export default {
  methods: {
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      let angleInRadians = (angleInDegrees-90) * Math.PI / 180.0
      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      };
    },

    describeArc(x, y, radius, startAngle, endAngle){
      let start = this.polarToCartesian(x, y, radius, endAngle)
      let end = this.polarToCartesian(x, y, radius, startAngle)
      let arcSweep = endAngle - startAngle <= 180 ? '0' : '1'
      let d = [
          'M', start.x, start.y, 
          'A', radius, radius, 0, arcSweep, 0, end.x, end.y,
          'L', x,y,
          'L', start.x, start.y
      ].join(' ')
      return d
    },

    calcRadiusMax(nRadius) {
      if (nRadius > 359.99999) {
        return 359.99999
      } else {
        return nRadius
      }
    }
  }
}